import React from 'react'
import AppLayout from '../../../layout/components/AppLayout'
import { NavLink } from 'react-router-dom'

const withFmsLayout = OriginalComponent =>(props) =>{

  return (
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-2'>
                        <div className='list-group rounded-0'>
                            <NavLink className="list-group-item" aria-current="page" to={"/fms/dashboard"} >Dashboard</NavLink>
                            <NavLink className="list-group-item" aria-current="page" to={"/fms/barcode-list"} >Barcodes</NavLink>
                            <NavLink className="list-group-item" aria-current="page" to={"/fms/document-list"} >Document List</NavLink>
                            <NavLink className="list-group-item" aria-current="page" to={"/fms/search"} >Document Search</NavLink>
                        </div>
                    </div>
                    <div className='col-md-10'>
                        <OriginalComponent />
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default withFmsLayout